if (!customElements.get('family-list')) {
  // Endless loop through the families; hover or focus pauses it, leaving the list resumes it
  class FamilyList extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.family-list__list');
      this.items = [...this.querySelectorAll('[data-family-item]')];
      this.slides = [...this.querySelectorAll('[data-family-image]')];
      this.pauseButton = this.querySelector('[data-family-pause]');
      this.index = 0;

      this.items.forEach((item, index) => {
        item.addEventListener('mouseenter', () => this.select(index));
        item.addEventListener('focusin', () => this.select(index));
        item.querySelector('.family-list__progress').addEventListener('animationend', () => this.advance());
      });
      this.list.addEventListener('mouseleave', () => this.release());
      this.list.addEventListener('focusout', (event) => {
        if (!this.list.contains(event.relatedTarget)) this.release();
      });
      this.slides.forEach((slide) =>
        slide.addEventListener('transitionend', () => {
          if (!slide.classList.contains('is-active')) slide.classList.remove('is-leaving');
        })
      );
      this.pauseButton?.addEventListener('click', () => this.togglePause());

      const canAutoplay =
        this.hasAttribute('data-autoplay') &&
        this.items.length > 1 &&
        window.matchMedia('(min-width: 990px)').matches &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (canAutoplay) this.start();
    }

    start() {
      this.classList.add('is-running');
      this.pauseButton.hidden = false;
    }

    togglePause() {
      const paused = this.classList.toggle('is-paused');
      this.pauseButton.setAttribute(
        'aria-label',
        paused ? this.pauseButton.dataset.labelPlay : this.pauseButton.dataset.labelPause
      );
    }

    advance() {
      if (!this.classList.contains('is-running') || this.classList.contains('is-held')) return;
      const next = (this.index + 1) % this.items.length;
      this.slides[this.index].classList.add('is-leaving');
      this.show(next);
    }

    select(index) {
      if (this.classList.contains('is-running')) this.classList.add('is-held');
      this.show(index);
    }

    release() {
      if (this.list.matches(':hover') || this.list.contains(document.activeElement)) return;
      this.classList.remove('is-held');
    }

    show(index) {
      this.index = index;
      this.items.forEach((item, i) => item.classList.toggle('is-active', i === index));
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        if (i === index) slide.classList.remove('is-leaving');
      });
    }
  }

  customElements.define('family-list', FamilyList);
}
